/**
 * The signed-in home's band (web-account-pages, signed-in-home.html Variant B
 * Band 4 Stacked), under the shorter hero: the welcome with the next session,
 * Waiting on you, Coming up. Each part draws nothing when it has nothing.
 */
import { ComingUp } from '../../pieces/coming-up';
import { HomeWelcome } from '../../pieces/home-welcome';
import { NextSession } from '../../pieces/next-session';
import { WaitingOnYou } from '../../pieces/waiting-on-you';
import account from '../../styles/account.module.css';
import shared from '../../styles/shared.module.css';
import css from './SignedInBand.module.css';

export function SignedInBand() {
  return (
    <section className={css.band} aria-label="Your bookings">
      <div className={shared.wrap}>
        <div className={account.sec}>
          <HomeWelcome />
          <NextSession />
        </div>
        <WaitingOnYou />
        <ComingUp />
      </div>
    </section>
  );
}
